export default class Header {

    constructor() {
        if (document.querySelector('header .logo') && document.querySelector('header .offer')) {
            this.checkBg()
        }

        if (document.querySelector('header .burger')) {
            this.nav();
        }
    }

    nav() {
        const burger = document.querySelector('header .burger');
        const logo = document.querySelector('header .logo');

        burger.removeEventListener('click', this.handleClick);
        burger.addEventListener('click', this.handleClick);

        window.addEventListener('keyup', function (e) {
            if (e.keyCode == 27 && document.body.classList.contains('nav-open')) {
                document.body.classList.remove('nav-open');
                logo.classList.remove('active');
            }
        });
    }

    handleClick(e) {
        e.preventDefault();

        const logo = document.querySelector('header .logo');

        document.body.classList.toggle('nav-open');

        logo.classList.toggle('active');
    };

    checkBg() {
        const logo = document.querySelector('header .logo');
        const offer = document.querySelector('header .offer');

        if (document.body.classList.contains('white-bg')) {
            logo.classList.add('black');
            offer.classList.add('white');
            offer.classList.remove('ghost');
        }
    }
}
